<template>
	<section :class="'type-' + data.type" class="container container--a module-margin" v-if="data">
		<div class="inner padding-bottom-lg padding-top-lg">
			<h2 class="module-title" v-if="data.title" v-html="data.title"></h2>
			<div class="module-content" v-if="data.content" v-html="data.content"></div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'info-module',
	props: ['data'],
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';

.module-information {
	background-color: var(--yellow);
	border-radius: $radius;
	&.type-gray {
		background-color: var(--gray);
	}
	.inner {
		padding-left: 15px;
		padding-right: 15px;
		max-width: 830px;
		margin: 0 auto;
	}
}
</style>
